export const defaultFieldLayout = {
    width: '100%', labelWidth: 'auto', inputWidth: '100%', textareaHeight: '',
    columnGap: '1rem', rowGap: '0.75rem', labelAlign: 'left', orientation: 'vertical', stackOnMobile: true
};
export type FieldLayout = typeof defaultFieldLayout;

export function validLayoutSize(value: string, allowAuto = false, allowEmpty = false): boolean {
    if (allowEmpty && !value.trim()) return true;
    if (allowAuto && value === 'auto') return true;
    return /^(?:\d+(?:\.\d+)?)(?:px|rem|em|ch|%)$/.test(value)
        && parseFloat(value) >= 0 && parseFloat(value) <= (value.endsWith('%') ? 100 : 10000);
}
export function normalizeFieldLayout(attrs: Record<string, unknown>): FieldLayout {
    const result = { ...defaultFieldLayout };
    for (const key of ['width', 'labelWidth', 'inputWidth', 'textareaHeight', 'columnGap', 'rowGap'] as const) {
        const value = String(attrs[key] ?? result[key]).trim();
        if (validLayoutSize(value, key === 'labelWidth', key === 'textareaHeight')) result[key] = value;
    }
    result.labelAlign = attrs.labelAlign === 'right' ? 'right' : 'left';
    result.orientation = attrs.orientation === 'horizontal' ? 'horizontal' : 'vertical';
    result.stackOnMobile = attrs.stackOnMobile !== false && attrs.stackOnMobile !== 'false';
    return result;
}
export function readFieldLayout(element: Element): FieldLayout {
    return normalizeFieldLayout(Object.fromEntries(Object.keys(defaultFieldLayout)
        .map(key => [key, element.getAttribute('data-' + key.replace(/[A-Z]/g, letter => '-' + letter.toLowerCase())) ?? defaultFieldLayout[key as keyof FieldLayout]])));
}
export function fieldLayoutAttributes(layout: FieldLayout): Record<string, string> {
    return Object.fromEntries(Object.entries(layout).map(([key, value]) =>
        ['data-' + key.replace(/[A-Z]/g, letter => '-' + letter.toLowerCase()), String(value)]));
}
